<h1 [innerHTML]="'donation.title' | translate"></h1>
<span [innerHTML]="'donation.description' | translate"></span>
<div class="split-line"></div>
